import React, { useEffect, useRef, useState } from 'react';
import './CounterSection.css';

const counters = [
  { value: 1000, suffix: '+', label: 'Years of combined experience' },
  { value: 550,  suffix: '+', label: 'Clients served since 2012' },
  { value: 65,   suffix: '+', label: 'Finance Professionals' },
  { value: 40,   suffix: '+', label: 'Expert CFOs' },
  { value: 13,   suffix: '+',  label: 'Years in business' },
];

const useCountUp = (target, duration = 1800, started = false) => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!started) return;
    let startTime = null;
    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      // Ease out cubic
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(Math.floor(eased * target));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [started, target, duration]);
  return count;
};

const CounterItem = ({ item, index, started }) => {
  const num = useCountUp(item.value, 1600 + index * 100, started);
  return (
    <div
      className="cs-item"
      style={{ animationDelay: `${index * 120}ms` }}
    >
      <div className="cs-item__num">
        {num}{item.suffix}
      </div>
      <div className="cs-item__bar" />
      <p className="cs-item__label">{item.label}</p>
    </div>
  );
};

const CounterSection = () => {
  const sectionRef = useRef(null);
  const [started, setStarted] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          setStarted(true);
          observer.disconnect();
        }
      },
      { threshold: 0.25 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className={`cs ${visible ? 'cs--visible' : ''}`} ref={sectionRef}>

      {/* Background geometric pattern */}
      <div className="cs__bg" aria-hidden="true">
        <div className="cs__bg-grid" />
        <div className="cs__bg-circle cs__bg-circle--1" />
        <div className="cs__bg-circle cs__bg-circle--2" />
      </div>

      <div className="cs__inner">

        {/* Left — Headline block */}
        <div className="cs__left">
          <div className="cs__eyebrow">
            <span className="cs__eyebrow-dot" />
            Our Impact
          </div>
          <h2 className="cs__headline">
            Premier<br />
            Outsourced<br />
            <em>CFO Services</em><br />
            Provider
          </h2>
          <p className="cs__sub">
            Trusted by businesses across the UAE and internationally for over a decade of financial excellence.
          </p>
          <a href="#contact" className="cs__cta">
            Work With Us
            <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8">
              <path d="M4 10h12M10 4l6 6-6 6" />
            </svg>
          </a>
        </div>

        {/* Right — Counters */}
        <div className="cs__right">
          <div className="cs__grid">
            {counters.map((item, index) => (
              <CounterItem key={index} item={item} index={index} started={started} />
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default CounterSection;